import {
    Component,
    Renderer2,
    ElementRef,
    ViewChild,
    afterNextRender,
    OnDestroy,
} from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
    selector: 'app-privacy',
    standalone: true,
    imports: [
        TranslocoPipe,
        NavbarComponent,
        FooterComponent
    ],
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.css'],
})
export class PrivacyComponent implements OnDestroy {
    @ViewChild('sidebarWrapper') private el: ElementRef;
    navbarType = 'other';

    private removeScrollListener?: () => void;

    constructor(public renderer: Renderer2) {
        afterNextRender(() => {
            this.attachScrollListener();
        })
    }

    private attachScrollListener() {
        this.removeScrollListener = this.renderer.listen('window', 'scroll', this.scrollEvent);
    }

    ngOnDestroy() {
        // only removes when not in ssr
        this.removeScrollListener?.();
    }

    scrollEvent = (): void => {
        const scrollY = window.scrollY;
        var x = document.body.scrollHeight - scrollY;
        if (x < 970) {
            this.renderer.addClass(this.el.nativeElement, 'fixed-position-bottom');
            this.renderer.removeClass(this.el.nativeElement, 'fixed-position-top');
        } else if (scrollY > 180) {
            this.renderer.addClass(this.el.nativeElement, 'fixed-position-top');
            this.renderer.removeClass(this.el.nativeElement, 'fixed-position-bottom');
        } else if (scrollY < 180) {
            this.renderer.removeClass(this.el.nativeElement, 'fixed-position-top');
        }
    };
}
